import Qty from 'js-quantities';

/**
 * Returns a very important number
 * @param reagent
 * @param options
 * @returns {number}
 */
export function normalizeQuantities(reagent, options = {}) {
  const { logger } = options;
  if (reagent.ml !== undefined) {
    reagent.volume = {
      value: reagent.ml,
      units: 'ml',
    };
  } else if (!reagent.volume) {
    reagent.volume = {
      value: 0,
      units: 'l',
    };
  }
  if (reagent.g !== undefined) {
    reagent.mass = {
      value: reagent.g,
      units: 'g',
    };
  } else if (!reagent.mass) {
    reagent.mass = {
      value: 0,
      units: 'kg',
    };
  }

  if (reagent.volume) {
    const targetUnits = 'l';
    let convert = Qty.swiftConverter(reagent.volume.units, targetUnits);
    reagent.volume = {
      value: convert(reagent.volume.value),
      units: targetUnits,
    };
  }

  if (reagent.mass) {
    const targetUnits = 'kg';
    let convert = Qty.swiftConverter(reagent.mass.units, targetUnits);
    reagent.mass = {
      value: convert(reagent.mass.value),
      units: targetUnits,
    };
  }

  if (!reagent.volume && !reagent.mass) {
    logger?.error('reagent has no volume or mass');
  } else {
    if (reagent.volume && !reagent.mass) {
      logger?.info('reagent has volume but no mass, assuming density of 1kg/l');
      reagent.mass = {
        value: reagent.volume.value,
        units: 'kg',
      };
    }
    if (reagent.mass && !reagent.volume) {
      logger?.info('reagent has mass but no volume, assuming density of 1kg/l');
      reagent.volume = {
        value: reagent.mass.value,
        units: 'l',
      };
    }
  }
}
